import { render, staticRenderFns } from "./DetalleCliente.vue?vue&type=template&id=6773e736&lang=pug&"
import script from "./DetalleCliente.vue?vue&type=script&lang=js&"
export * from "./DetalleCliente.vue?vue&type=script&lang=js&"
import style0 from "./DetalleCliente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports